import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { UiRoutes } from '@lsq-frontend/angular-shared/app-constants';
import { SingletonServiceGuard } from '@lsq-frontend/angular-shared/features/generic-get-services';
import { UserService } from '@lsq-frontend/angular-shared/features/user-service';
import { combineLatest, Observable, of } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { EulaService } from './eula.service';

@Injectable({
    providedIn: 'root'
})
export class EulaGuard implements CanActivate {
    constructor(
        private _userService: UserService,
        private _eulaService: EulaService,
        private _router: Router
    ) {
        SingletonServiceGuard.register('EulaGuard');
    }

    public canActivate(): Observable<boolean | UrlTree> {
        const loginUrl = `/${UiRoutes.Login}`;

        return combineLatest([this._userService.user$, this._eulaService.eulaIsAccepted$]).pipe(
            switchMap(([user, eulaIsAccepted]) => {
                if (user === null) {
                    return of(this._router.parseUrl(loginUrl));
                }

                if (eulaIsAccepted) {
                    return of(this._router.parseUrl(this._userService.getHomeUrl()));
                }
                return of(true);
            })
        );
    }
}
